import DebitNotesTable from "components/DebitNotes/DebitNotesTable";

const DebitNotes = () => {
    return (
        <DebitNotesTable />
    );
}
export default DebitNotes;
